import { useEffect, useRef, type ReactNode } from 'react';

/** Native disclosure: ordinary buttons retain their keyboard and disabled semantics. */
export function ActionMenu({
  label,
  children,
  icon,
  showIndicator = true,
}: {
  label: string;
  children: ReactNode;
  icon?: ReactNode;
  showIndicator?: boolean;
}) {
  const root = useRef<HTMLDetailsElement>(null);
  useEffect(() => {
    function dismiss(event: PointerEvent) {
      if (root.current && !root.current.contains(event.target as Node)) root.current.open = false;
    }
    document.addEventListener('pointerdown', dismiss);
    return () => document.removeEventListener('pointerdown', dismiss);
  }, []);
  return (
    <details
      ref={root}
      className="action-menu"
      onKeyDown={(event) => {
        if (event.key === 'Escape' && root.current?.open) {
          event.stopPropagation();
          root.current.open = false;
          root.current.querySelector('summary')?.focus();
        }
      }}
    >
      <summary>
        {icon}
        {label}
        {showIndicator ? <span aria-hidden="true">⌄</span> : null}
      </summary>
      <div
        className="action-menu__items"
        onClick={(event) => {
          const button = (event.target as HTMLElement).closest('button');
          if (button && !button.disabled && root.current) {
            root.current.open = false;
            root.current.querySelector('summary')?.focus();
          }
        }}
      >
        {children}
      </div>
    </details>
  );
}
